import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../wayfinder'
import pin from './pin'
import settings from './settings'
import users from './users'
import staff from './staff'
import departments from './departments'
import colleges from './colleges'
/**
* @see \App\Http\Controllers\Auth\PinBasedRegistrationController::register
 * @see app/Http/Controllers/Auth/PinBasedRegistrationController.php:64
 * @route '/admin/register'
 */
export const register = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: register.url(options),
    method: 'post',
})

register.definition = {
    methods: ["post"],
    url: '/admin/register',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Auth\PinBasedRegistrationController::register
 * @see app/Http/Controllers/Auth/PinBasedRegistrationController.php:64
 * @route '/admin/register'
 */
register.url = (options?: RouteQueryOptions) => {
    return register.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Auth\PinBasedRegistrationController::register
 * @see app/Http/Controllers/Auth/PinBasedRegistrationController.php:64
 * @route '/admin/register'
 */
register.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: register.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\AdminController::dashboard
 * @see app/Http/Controllers/AdminController.php:21
 * @route '/admin/dashboard'
 */
export const dashboard = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: dashboard.url(options),
    method: 'get',
})

dashboard.definition = {
    methods: ["get","head"],
    url: '/admin/dashboard',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\AdminController::dashboard
 * @see app/Http/Controllers/AdminController.php:21
 * @route '/admin/dashboard'
 */
dashboard.url = (options?: RouteQueryOptions) => {
    return dashboard.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AdminController::dashboard
 * @see app/Http/Controllers/AdminController.php:21
 * @route '/admin/dashboard'
 */
dashboard.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: dashboard.url(options),
    method: 'get',
})
/**
* @see \App\Http\Controllers\AdminController::dashboard
 * @see app/Http/Controllers/AdminController.php:21
 * @route '/admin/dashboard'
 */
dashboard.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: dashboard.url(options),
    method: 'head',
})
const admin = {
    pin: Object.assign(pin, pin),
register: Object.assign(register, register),
dashboard: Object.assign(dashboard, dashboard),
settings: Object.assign(settings, settings),
users: Object.assign(users, users),
staff: Object.assign(staff, staff),
departments: Object.assign(departments, departments),
colleges: Object.assign(colleges, colleges),
}

export default admin